import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

//prime React
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
//components
import Select from "../../../../components/input/Select";
import NumberInput from "../../../../components/input/NumberInput";
//services

import TextareaInput from "../../../../components/input/TextareaInput";
import CopyTextInput from "../../../../components/input/CopyTextInput";

import { postSendDays } from "../../../../services/Enterprise/WhatsppConfig/postSendDays";
import { useQuery } from "react-query";
import { getSendDays } from "../../../../services/Enterprise/WhatsppConfig/getSendDays";
import { confirmDialog } from "primereact/confirmdialog";
import { deleteSendDays } from "../../../../services/Enterprise/WhatsppConfig/deleteSendDays";
import { fi } from "date-fns/locale";
import { Skeleton } from "primereact/skeleton";
import { useAppContext } from "../../../../context/AppContext";

export default function WhatsappSendDays(id) {
  const { permissions } = useAppContext();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const variables = [
    { id: 1, name: "@nome_cli" },
    { id: 2, name: "@nome_empreendimento" },
    { id: 3, name: "@valor_parcelas" },
    { id: 4, name: "@data_vencimento" },
    { id: 5, name: "@link_boleto" },
  ];
  const columns = [
    { field: "days", header: "Quantidade de dias" },
    {
      field: "before_or_after",
      header: "Antes / Após Vencimento",
      body: (rowData) => {
        return rowData.before_or_after === "before" ? "Antes" : "Após";
      },
    },
    { field: "text", header: "Mensagem" },
  ];

  const condition = [
    { value: "before", label: "Antes do Vencimento" },
    { value: "after", label: "Após o vencimento" },
  ];

  const form = useForm();
  const errors = form.formState.errors;

  useEffect(() => {
    form.setValue(
      "text",
      "Olá @nome_cli, este é um lembrete de sua parcela no valor de @valor_parcelas com vencimento para @data_vencimento. Segue o link do boleto: @link_boleto"
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  function onSubmit(data) {
    setLoading(true);
    let obj = {
      type: 2, //WhatsApp
      days: data.days_send,
      before_or_after: data.before_or_after,
      text: data.text,
      enterprise_id: id.id,
    };

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );
    postSendDays(obj)
      .then(() => {
        refetch().then(() => {
          setLoading(false);
          toast.update(notification, {
            render: "Dias de envio adicionados com sucesso!",
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        });
      })
      .catch((error) => {
        setLoading(false);
        toast.update(notification, {
          render: "Não foi possível adicionar os dias de envio!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao adicionar dias de envio:", error);
      });
  }

  const removeOption = (e, rowData) => {
    e.preventDefault();
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => sendDaysDelete(rowData.id),
    });
  };

  const sendDaysDelete = async (id) => {
    //    console.log(id);
    try {
      const notification = toast.loading("Por favor aguarde...");
      await deleteSendDays(id).then(() => {
        refetch().then(() => {
          toast.update(notification, {
            render: "Dia de envio deletado com sucesso!",
            autoClose: 1000,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        });
      });
    } catch (e) {
      toast.error(`Não foi possível deletar dia de envio!`);
    }
  };

  //USE QUERY PARA LISTAR / ATUALIZAR LISTA DE PARCELAS
  const {
    data: send_days,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [`send_days`],
    queryFn: () => getSendDays(2),
    enabled: !!permissions.includes("91")
  });

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-8">
            <h4>Informe os dias de disparo das mensagens</h4>
            <div className="row">
              <div className="col-md-6 mt-4">
                <h4>
                  {" "}
                  Quantidade de Dias
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon px-2 pi 
                    pi-info-circle p-text-secondary"
                    data-pr-tooltip="Configure a quantidade de dias que sera enviada antes ou após o vencimento do boleto"
                    style={{ cursor: "pointer" }}
                  ></i>{" "}
                </h4>
                <NumberInput
                  suffix=""
                  placeholder="0"
                  max={90}
                  required={true}
                  minFractionDigits={0}
                  name="days_send"
                  control={form.control}
                  label="Dias"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="col-md-6 mt-4">
                <h4>
                  {" "}
                  Condição
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon mx-2 pi 
                    pi-info-circle p-text-secondary"
                    data-pr-tooltip="Configure se a mensagem será de cobrança ou lembrete"
                    style={{ cursor: "pointer" }}
                  ></i>
                </h4>
                <Select
                  isRequired={true}
                  name="before_or_after"
                  errors={errors}
                  label="Escolha"
                  options={condition}
                  control={form.control}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <h4>
              Variáveis <Tooltip target=".custom-target-icon" />
              <i
                className="custom-target-icon px-2 pi 
              pi-info-circle p-text-secondary"
                data-pr-tooltip="Utilize para automatizar dados da mensagem"
                style={{ cursor: "pointer" }}
              ></i>{" "}
            </h4>
            <div className="d-flex flex-wrap">
              {variables.map((v) => (
                <div className="p-2 my-1" key={v.id}>
                  <CopyTextInput
                    text={v.name}
                    onClick={() => {
                      toast.success(`Texto copiado com sucesso`);
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 mt-4">
              <h4>
                {" "}
                Mensagem de Envio
                <Tooltip target=".custom-target-icon" />
                <i
                  className="custom-target-icon px-2 pi 
        pi-info-circle p-text-secondary"
                  data-pr-tooltip="Configure sua mensagem para disparo de avisos de cobrança"
                  style={{ cursor: "pointer" }}
                ></i>{" "}
              </h4>
              <div className="col-md-12 mt-4">
                <TextareaInput
                  isRequired={true}
                  suffix=""
                  max={240}
                  minFractionDigits={0}
                  name="text"
                  control={form.control}
                  label="Mensagem"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
            </div>
            <div className="col-md-4 mt-4 align-self-end text-end">
              {" "}
              <Button
                rounded
                type="submit"
                loading={loading}
                iconPos="right"
                label="Cadastrar"
                icon="fa-solid fa-circle-chevron-right"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>

          <hr className="my-4" />
          <div className="px-2 pb-3">
            {isLoading == true && (
              <>
                <Skeleton variant="rect" width="100%" height={300} />
              </>
            )}

            {!isLoading && (
              <DataTable
                rows={8}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[8, 10, 12]}
                value={send_days}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={col.body}
                  />
                ))}
                <Column
                  header="Excluir"
                  body={(rowData) => (
                    <div className="d-flex">
                      <div className="mr-2">
                        <button
                          className="btn btn-danger btn-btn-sm"
                          onClick={(e) => removeOption(e, rowData)}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </div>
                    </div>
                  )}
                />
              </DataTable>
            )}
          </div>
        </div>
      </form>
    </>
  );
}
